import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const EndocrineProgesteroneDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const cyp11a1 = getGenePalette(geneColors.CYP11A1);
  const akr1c = getGenePalette(geneColors.AKR1C);
  const hsd3b1 = getGenePalette(geneColors.HSD3B1);
  const srd5a1 = getGenePalette(geneColors.SRD5A1);
  const cyp17a1 = getGenePalette(geneColors.CYP17A1);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18293_224306)">
        <rect width={1024} height={1000} transform="translate(0 204)" fill="white" />
        <g id="progesterone-diagram">
          <rect width={1024} height={1000} transform="translate(0 204)" fill="white" />
          <g id="lines">
            <path
              id="Vector"
              d="M207.1 750.846L214.691 748.069L208.491 742.883L207.1 750.846ZM452.433 458.579L452.882 458.042L451.808 457.144L451.359 457.681L451.896 458.13L452.433 458.579ZM211.142 746.013L211.679 746.462L452.433 458.579L451.896 458.13L451.359 457.681L210.605 745.564L211.142 746.013Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_2">
            <path
              id="Vector_2"
              d="M695.1 683.651L702.691 680.874L696.491 675.688L695.1 683.651ZM737.887 633.579L738.337 633.042L737.263 632.144L736.814 632.681L737.35 633.13L737.887 633.579ZM699.142 678.818L699.679 679.267L737.887 633.579L737.35 633.13L736.814 632.681L698.605 678.369L699.142 678.818Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_3">
            <path
              id="Vector_3"
              d="M640.1 797.651L647.691 794.874L641.491 789.688L640.1 797.651ZM682.887 747.579L683.337 747.042L682.263 746.144L681.814 746.681L682.35 747.13L682.887 747.579ZM644.142 792.818L644.679 793.267L682.887 747.579L682.35 747.13L681.814 746.681L643.605 792.369L644.142 792.818Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_4">
            <path
              id="Vector_4"
              d="M608.8 797.651L601.209 794.874L607.41 789.688L608.8 797.651ZM566.013 747.579L565.564 747.042L566.638 746.144L567.087 746.681L566.55 747.13L566.013 747.579ZM604.759 792.818L604.222 793.267L566.013 747.579L566.55 747.13L567.087 746.681L605.296 792.369L604.759 792.818Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_5">
            <path
              id="Vector_5"
              d="M804.806 679.652L797.215 676.875L803.416 671.69L804.806 679.652ZM619.012 458.579L618.562 458.042L619.636 457.144L620.085 457.681L619.548 458.13L619.012 458.579ZM800.765 674.82L800.228 675.269L619.012 458.579L619.548 458.13L620.085 457.681L801.302 674.371L800.765 674.82Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_6">
            <path
              id="Vector_6"
              d="M426.919 746.776L419.329 743.999L425.529 738.814L426.919 746.776ZM333.013 635.579L332.564 635.042L333.638 634.144L334.087 634.681L333.55 635.13L333.013 635.579ZM422.878 741.944L422.341 742.393L333.013 635.579L333.55 635.13L334.087 634.681L423.415 741.495L422.878 741.944Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_7">
            <path
              id="Vector_7"
              d="M530.498 684.783L522.49 685.879L525.545 678.395L530.498 684.783ZM378.912 623.655L378.264 623.39L378.793 622.094L379.441 622.359L379.177 623.007L378.912 623.655ZM524.665 682.402L524.401 683.05L378.912 623.655L379.177 623.007L379.441 622.359L524.93 681.753L524.665 682.402Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_8">
            <path
              id="Vector_8"
              d="M208.042 940L212.083 933L204 933L208.042 940ZM208.741 790.7L208.741 790L207.341 790L207.341 790.7L208.041 790.7L208.741 790.7ZM208.042 933.7L208.742 933.7L208.741 790.7L208.041 790.7L207.341 790.7L207.342 933.7L208.042 933.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_9">
            <path
              id="Vector_9"
              d="M431.042 881L435.083 874L427 874L431.042 881ZM431.741 790.7L431.741 790L430.341 790L430.341 790.7L431.041 790.7L431.741 790.7ZM431.042 874.7L431.742 874.7L431.741 790.7L431.041 790.7L430.341 790.7L430.342 874.7L431.042 874.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_10">
            <path
              id="Vector_10"
              d="M860.042 836L864.083 829L856 829L860.042 836ZM860.741 745.7L860.741 745L859.341 745L859.341 745.7L860.041 745.7L860.741 745.7ZM860.042 829.7L860.742 829.7L860.741 745.7L860.041 745.7L859.341 745.7L859.342 829.7L860.042 829.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_11">
            <path
              id="Vector_11"
              d="M208.042 1042L212.083 1035L204 1035L208.042 1042ZM208.742 977.7L208.742 977L207.342 977L207.342 977.7L208.042 977.7L208.742 977.7ZM208.042 1035.7L208.742 1035.7L208.742 977.7L208.042 977.7L207.342 977.7L207.342 1035.7L208.042 1035.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="Report titles">
            <rect width={103} height={28} transform="translate(487 440)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={487.484} y={459.448}>
                Pregnenolone
              </tspan>
            </text>
          </g>
          <g id="Report titles_2">
            <rect width={182} height={28} transform="translate(116 753)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_2"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={116.086} y={772.448}>
                5α-Dihydroprogesterone
              </tspan>
            </text>
          </g>
          <g id="Report titles_3">
            <rect width={182} height={28} transform="translate(338 753)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_3"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={338.195} y={772.448}>
                5β-Dihydroprogesterone
              </tspan>
            </text>
          </g>
          <g id="Report titles_4">
            <rect width={147} height={28} transform="translate(555 807)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_4"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={555.266} y={826.448}>
                17-OH Progesterone
              </tspan>
            </text>
          </g>
          <g id="Report titles_5">
            <rect width={42} height={28} transform="translate(837 845)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_5"
              fill="#00BF86"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={837.391} y={864.448}>
                DHEA
              </tspan>
            </text>
          </g>
          <g id="Report titles_6">
            <rect width={131} height={28} transform="translate(142 943)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_6"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={142.188} y={962.448}>
                Allopregnanolone
              </tspan>
            </text>
          </g>
          <g id="Report titles_7">
            <rect width={118} height={28} transform="translate(148 1051)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_7"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={148.172} y={1070.46}>
                α-Pregnanediol
              </tspan>
            </text>
          </g>
          <g id="Report titles_8">
            <rect width={118} height={28} transform="translate(371 886)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_8"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={371.367} y={905.464}>
                β-Pregnanediol
              </tspan>
            </text>
          </g>
          <g id="Report titles_9">
            <rect width={103} height={28} transform="translate(263 604)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_9"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Bold"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={265.094} y={623.464}>
                Progesterone
              </tspan>
            </text>
          </g>
          <g id="Report titles_10">
            <rect width={151} height={28} transform="translate(684 604)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_10"
              fill="#5220DD"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={684.039} y={623.448}>
                17-OH Pregnenolone
              </tspan>
            </text>
          </g>
          <g id="report-label">
            <g id="Report titles_11">
              <rect width={93} height={28} transform="translate(490 266)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_11"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={490.243} y={286.12}>
                  Cholesterol
                </tspan>
              </text>
            </g>
            <g id="lines_12">
              <path
                id="Vector_12"
                d="M537.158 298.7L537.158 298L535.758 298L535.758 298.7L536.458 298.7L537.158 298.7ZM536.458 435L540.5 428L532.417 428L536.458 435ZM536.458 298.7L535.758 298.7L535.758 428.7L536.458 428.7L537.158 428.7L537.158 298.7L536.458 298.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="gene-CYP11A1" {...geneGroupProps("CYP11A1", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M487 343C487 340.791 488.791 339 491 339H583C585.209 339 587 340.791 587 343V371C587 373.209 585.209 375 583 375H491C488.791 375 487 373.209 487 371V343Z"
                fill={cyp11a1.lozengeFill}
              />
              <text
                id="gene-lozenge-label"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={508.414} y={362.448}>
                  CYP11A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp11a1"
              groupId="gene-snps"
              genePalette={cyp11a1}
              startX={495}
              startY={377}
              snpCount={getGeneSnpCount("CYP11A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-AKR1C" {...geneGroupProps("AKR1C", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M158 839C158 836.791 159.791 835 162 835H254C256.209 835 258 836.791 258 839V867C258 869.209 256.209 871 254 871H162C159.791 871 158 869.209 158 867V839Z"
                fill={akr1c.lozengeFill}
              />
              <text
                id="gene-lozenge-label_2"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={184.547} y={858.448}>
                  AKR1C
                </tspan>
              </text>
              <path
                id="*_3"
                d="M268.748 831.406V833.824L264.818 833.695L267.064 836.934L264.861 838.23L262.874 834.731L260.887 838.23L258.684 836.934L260.93 833.695L257 833.824L257 831.406L260.93 831.535L258.684 828.296L260.887 827L262.874 830.499L264.861 827L267.064 828.296L264.818 831.535L268.748 831.406Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="akr1c"
              groupId="gene-snps_2"
              genePalette={akr1c}
              startX={166}
              startY={873}
              snpCount={getGeneSnpCount("AKR1C", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-HSD3B1" {...geneGroupProps("HSD3B1", onGeneClick)}>
            <g id="gene-lozenge_7">
              <path
                d="M322 525C322 522.791 323.791 521 326 521H418C420.209 521 422 522.791 422 525V553C422 555.209 420.209 557 418 557H326C323.791 557 322 555.209 322 553V525Z"
                fill={hsd3b1.lozengeFill}
              />
              <text
                id="gene-lozenge-label_3"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={344.742} y={544.448}>
                  HSD3B1
                </tspan>
              </text>
              <path
                id="*_4"
                d="M432.748 517.406V519.824L428.818 519.695L431.064 522.934L428.861 524.23L426.874 520.731L424.887 524.23L422.684 522.934L424.93 519.695L421 519.824L421 517.406L424.93 517.535L422.684 514.296L424.887 513L426.874 516.499L428.861 513L431.064 514.296L428.818 517.535L432.748 517.406Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="hsd3b1"
              groupId="gene-snps_3"
              genePalette={hsd3b1}
              startX={330}
              startY={559}
              snpCount={getGeneSnpCount("HSD3B1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SRD5A1" {...geneGroupProps("SRD5A1", onGeneClick)}>
            <g id="gene-lozenge_8">
              <path
                d="M215 668C215 665.791 216.791 664 219 664H311C313.209 664 315 665.791 315 668V696C315 698.209 313.209 700 311 700H219C216.791 700 215 698.209 215 696V668Z"
                fill={srd5a1.lozengeFill}
              />
              <text
                id="gene-lozenge-label_4"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={238.039} y={687.448}>
                  SRD5A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="srd5a1"
              groupId="gene-snps_4"
              genePalette={srd5a1}
              startX={223}
              startY={702}
              snpCount={getGeneSnpCount("SRD5A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CYP17A1" {...geneGroupProps("CYP17A1", onGeneClick)}>
            <g id="gene-lozenge_9">
              <path
                d="M515 700C515 697.791 516.791 696 519 696H611C613.209 696 615 697.791 615 700V728C615 730.209 613.209 732 611 732H519C516.791 732 515 730.209 515 728V700Z"
                fill={cyp17a1.lozengeFill}
              />
              <text
                id="gene-lozenge-label_5"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={535.742} y={719.448}>
                  CYP17A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp17a1"
              groupId="gene-snps_5"
              genePalette={cyp17a1}
              startX={523}
              startY={734}
              snpCount={getGeneSnpCount("CYP17A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-HSD3B1_2" {...geneGroupProps("HSD3B1", onGeneClick)}>
            <g id="gene-lozenge_10">
              <path
                d="M638 699C638 696.791 639.791 695 642 695H734C736.209 695 738 696.791 738 699V727C738 729.209 736.209 731 734 731H642C639.791 731 638 729.209 638 727V699Z"
                fill={hsd3b1.lozengeFill}
              />
              <text
                id="gene-lozenge-label_6"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={660.742} y={718.448}>
                  HSD3B1
                </tspan>
              </text>
              <path
                id="*_5"
                d="M748.748 691.406V693.824L744.818 693.695L747.064 696.934L744.861 698.23L742.874 694.731L740.887 698.23L738.684 696.934L740.93 693.695L737 693.824L737 691.406L740.93 691.535L738.684 688.296L740.887 687L742.874 690.499L744.861 687L747.064 688.296L744.818 691.535L748.748 691.406Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="hsd3b1-2"
              groupId="gene-snps_6"
              genePalette={hsd3b1}
              startX={646}
              startY={733}
              snpCount={getGeneSnpCount("HSD3B1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CYP17A1_2" {...geneGroupProps("CYP17A1", onGeneClick)}>
            <g id="gene-lozenge_11">
              <path
                d="M808 695C808 692.791 809.791 691 812 691H904C906.209 691 908 692.791 908 695V723C908 725.209 906.209 727 904 727H812C809.791 727 808 725.209 808 723V695Z"
                fill={cyp17a1.lozengeFill}
              />
              <text
                id="gene-lozenge-label_7"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={828.742} y={714.448}>
                  CYP17A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp17a1-2"
              groupId="gene-snps_7"
              genePalette={cyp17a1}
              startX={816}
              startY={729}
              snpCount={getGeneSnpCount("CYP17A1", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-CYP17A1_3" {...geneGroupProps("CYP17A1", onGeneClick)}>
            <g id="gene-lozenge_12">
              <path
                d="M640 517C640 514.791 641.791 513 644 513H736C738.209 513 740 514.791 740 517V545C740 547.209 738.209 549 736 549H644C641.791 549 640 547.209 640 545V517Z"
                fill={cyp17a1.lozengeFill}
              />
              <text
                id="gene-lozenge-label_8"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={660.742} y={536.448}>
                  CYP17A1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="cyp17a1-3"
              groupId="gene-snps_8"
              genePalette={cyp17a1}
              startX={648}
              startY={551}
              snpCount={getGeneSnpCount("CYP17A1", expectedSnps, geneColors)}
            />
          </g>
        </g>
      </g>
    </>
  );
};

const SvgEndocrineProgesteroneDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1024}
    height={1000}
    viewBox="0 204 1024 1000"
    fill="none"
    {...props}
  >
    <EndocrineProgesteroneDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18293_224306">
        <rect width={1024} height={1204} fill="white" />
      </clipPath>
      <clipPath id="clip1_18293_224306">
        <rect width={1024} height={1000} fill="white" transform="translate(0 204)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgEndocrineProgesteroneDiagram;
